<template>
	<button
		:style="{
			opacity: disabled ? 0.6 : 1,
		}"
		class="w-full rounded-md shadow-lg transition-all"
		:class="{
			[border]: border,
			[`bg-${color}`]: !color.startsWith('#'),
			[`bg-[${color}]`]: color.startsWith('#'),
			'hover:scale-[1.1] active:scale-[0.95]': !disabled,
		}"
		:disabled="disabled"
	>
		<slot></slot>
	</button>
</template>

<script>
export default {
	name: 'CustomButton',
	props: {
		color: {
			type: String,
			default: 'primary-1',
		},
		border: {
			type: String,
			default: '',
		},
		label: {
			type: String,
			default: '',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
};
</script>